
import Vue from 'vue'
import {createPopper, Instance} from '@popperjs/core'
import {clone, find, findIndex, isArray} from 'lodash'

export interface SelectOption {
  key: string;
  value: string;
}

export default Vue.extend({
  name: 'UiSelect',
  props: {
    multiSelect: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Selecteer een item'
    },
    value: {
      type: [Object, Array],
      default(): SelectOption[] | SelectOption | null {
        return null
      }
    },
    options: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data(): {
    internalValue: SelectOption[] | SelectOption | null,
    popperInstance: Instance | null,
    isOpen: boolean
  } {
    return {
      internalValue: null,
      popperInstance: null,
      isOpen: false,
    }
  },
  mounted() {
    createPopper(this.$refs.selectInput as Element, this.$refs.selectDropdown as HTMLElement);
  },
  watch: {
    value: {
      immediate: true,
      handler(val: SelectOption[] | SelectOption | null) {
        this.internalValue = clone(val)
      }
    }
  },
  computed: {
    displayValue(): string {
      if (this.internalValue === null || (isArray(this.internalValue) && this.internalValue.length === 0)) {
        return this.placeholder
      }

      if (isArray(this.internalValue)) {
        const format = this.internalValue.map(e => find<SelectOption>(this.options as SelectOption[], {key: e.key})?.value ?? "")
        return format.join(', ')
      } else {
        return find<SelectOption>(this.options as SelectOption[], {key: this.internalValue.key})?.value ?? ""
      }
    }
  },
  methods: {
    open() {
      this.isOpen = true;
      this.popperInstance = createPopper(this.$refs.selectInput as Element, this.$refs.selectDropdown as HTMLElement);
    },
    close() {
      if (this.popperInstance !== null) {
        this.popperInstance.destroy();
      }
      this.isOpen = false
    },
    isOptionSelected(option: SelectOption) {
      if (this.internalValue === null) {
        return false
      }

      if (isArray(this.internalValue)) {
        return (this.internalValue as SelectOption[]).some(e => e.key === option.key)
      }

      return this.internalValue.key === option.key
    },
    selectOption(val: SelectOption) {
      if (this.isOptionSelected(val)) {
        if (this.multiSelect) {
          const index = findIndex((this.internalValue as SelectOption[]), {
            key: val.key
          });
          (this.internalValue as SelectOption[]).splice(index, 1)
        } else {
          this.internalValue = null
        }
      } else {
        if (this.multiSelect) {
          if (this.internalValue === null) {
            this.internalValue = [val]
          } else {
            (this.internalValue as SelectOption[]).push(val)
          }
        } else {
          this.internalValue = val
        }
      }
      this.updateValue(this.internalValue)
    },
    updateValue(val: SelectOption[] | SelectOption | null) {
      this.$emit('input', JSON.parse(JSON.stringify(val)))
    }
  }
})
